module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA4CAYAAAC7UXvqAAAAAXNSR0IArs4c6QAAATBJREFUaEPtmjEOAiEQRf/2nsDEe3gFD+D22kxlryfQ3moa7d0DeAXvYfQEHsAQMVGyBWTALOZTDx/mzwMCoUGhpqprACsvvxeRXYmhmhKiqjoHcAq0WxHpco9XKoEDgEUw2aOILGtJwLnvqvDZOhFpmUDgQCmEWIFY1FiBPqdUlQgRoVgHiJDFKQDchYgQETI6QISMBnIXGgRC/g47AzAyVvTdfQpgEmhdAVwy6T8AnN0du/GvB9tMwr+W2bgEbgDGvx4503j3v0jAPUDVi5ArZdWLOBOLXzK8Uia4ypN4ECdxQsWiQrkGomx6BXENcA0k4NIXSoSIEBEyOkCEjAZyFyJCA0Wo+q8GdX/28A8F9X63MWKd1L3INpo0A2MwEzAaaO7OCpgtNAqwAkYDzd2fNsTwHzL2/JAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/addfile.png
// module id = 3/Um
// module chunks = 1